import { useEffect } from "react";
import backgroundMusic from "../assets/ti-amo.mp3";
import backgroundVideo from "../assets/background.mp4";

const discordPath =
  "M19.5 5.3A16.5 16.5 0 0 0 15.4 4l-.5 1a15 15 0 0 0-5.8 0l-.5-1a16.5 16.5 0 0 0-4.1 1.3C1.9 9.2 1.2 13 1.6 16.8A16.8 16.8 0 0 0 6.7 19l1.2-1.7a10.7 10.7 0 0 1-1.7-.8l.4-.3a12.5 12.5 0 0 0 10.8 0l.4.3a10.7 10.7 0 0 1-1.7.8l1.2 1.7a16.8 16.8 0 0 0 5.1-2.2c.5-4.4-.8-8.2-2.9-11.5Z";

function DiscordIcon(): React.JSX.Element {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d={discordPath} />
    </svg>
  );
}

export default function App(): React.JSX.Element {
  useEffect(() => {
    void import("./site");
  }, []);

  return (
    <>
      <div className="video-background" aria-hidden="true">
        <video
          id="backgroundVideo"
          muted
          loop
          playsInline
          preload="auto"
          disablePictureInPicture
        >
          <source src={backgroundVideo} type="video/mp4" />
        </video>
        <div className="video-shade" />
      </div>

      <div className="mood" aria-hidden="true">
        <span className="mood-fog mood-fog-one" />
        <span className="mood-fog mood-fog-two" />
        <span className="mood-fog mood-fog-three" />
      </div>
      <div className="noise" aria-hidden="true" />
      <div className="frost" aria-hidden="true" />
      <canvas id="rain" className="rain" aria-hidden="true" />

      <button
        className="sound-toggle"
        id="soundToggle"
        aria-label="Attiva o disattiva l'audio"
      >
        <svg className="sound-on" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M11 5 6 9H2v6h4l5 4V5Zm4.5 4.5a4 4 0 0 1 0 5m2.5-8a8 8 0 0 1 0 11" />
        </svg>
        <svg className="sound-off" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M11 5 6 9H2v6h4l5 4V5Zm5 4 5 5m0-5-5 5" />
        </svg>
      </button>

      <main>
        <div className="profile-stage">
          <section className="profile-shell" aria-label="Profilo di ayoitsaxto">
            <header className="profile-header">
              <div className="avatar-wrap">
                <div className="avatar">
                  <img id="discordAvatar" alt="Avatar Discord di ayoitsaxto" hidden />
                  <span id="avatarFallback">A</span>
                </div>
                <img
                  className="avatar-decoration"
                  id="avatarDecoration"
                  alt=""
                  aria-hidden="true"
                  hidden
                />
                <div className="status-bubble" id="statusBubble" hidden title="">
                  <span className="status-bubble-dots" aria-hidden="true">
                    <i />
                    <i />
                    <i />
                  </span>
                  <span className="status-bubble-text" id="statusBubbleText" />
                </div>
                <div className="status-dot" id="statusDot" title="Caricamento stato" />
              </div>

              <div className="profile-meta">
                <div className="badges" aria-hidden="true">
                  <span className="badge">★</span>
                  <span className="badge">◆</span>
                  <span className="badge">◈</span>
                </div>
                <h1 className="profile-name">ayoitsaxto</h1>
                <p className="bio">developer · digital creator</p>
              </div>
            </header>

            <div className="widget-row">
              <a className="glass-card now-card" id="nowCard" hidden aria-live="polite">
                <img className="now-image" id="nowImage" alt="" hidden />
                <div className="card-copy">
                  <p className="card-title" id="nowTitle" />
                  <p className="card-sub" id="nowDetail" />
                </div>
              </a>

              <div className="glass-card presence-card" id="presenceCard">
                <div className="presence-orb" id="presenceOrb" data-status="offline">
                  <img className="presence-avatar" id="presenceAvatar" alt="" hidden />
                  <span className="presence-fallback" id="presenceFallback" aria-hidden="true">
                    ~
                  </span>
                </div>
                <div className="card-copy">
                  <p className="presence-label">right now</p>
                  <p className="card-title" id="presenceName">chillin'</p>
                  <p className="card-sub" id="presenceStatus">loading...</p>
                </div>
              </div>

              <a
                className="glass-card server-card"
                id="serverRow"
                href="https://discord.gg/BgJMr3TESf"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Entra nel server Discord"
              >
                <span className="server-watermark" aria-hidden="true">
                  <DiscordIcon />
                </span>
                <div className="server-icon" id="serverIcon">
                  <DiscordIcon />
                </div>
                <div className="card-copy">
                  <p className="card-title" id="serverName">la tana di axto</p>
                  <p className="card-sub server-stats">
                    <i className="server-online" />
                    <span id="serverStats">0 Online · 0 Members</span>
                  </p>
                </div>
                <span className="server-join">Join</span>
              </a>
            </div>

            <div className="profile-footer">
              <nav className="socials" aria-label="Social link">
                <a
                  href="https://t.me/sbxrra"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Telegram"
                  title="Telegram"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      className="fill"
                      d="M21.4 4.1 18.5 18c-.2 1-.8 1.2-1.7.7l-4.4-3.3-2.1 2.1c-.2.2-.4.4-.9.4l.3-4.5 8.2-7.5c.4-.3-.1-.5-.5-.2L7.2 12.1l-4.3-1.4c-.9-.3-.9-.9.2-1.3l16.8-6.5c.8-.3 1.5.2 1.5 1.2Z"
                    />
                  </svg>
                </a>

                <a
                  href="https://discord.com/users/508686620564652043"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Profilo Discord"
                  title="Discord"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d={discordPath} />
                    <circle className="fill" cx="8.7" cy="12.5" r="1.2" />
                    <circle className="fill" cx="15.3" cy="12.5" r="1.2" />
                  </svg>
                </a>

                <a
                  href="https://github.com/axtodev"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                  title="GitHub"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 2a10 10 0 0 0-3.2 19.5v-2.2c-2.7.6-3.3-1.1-3.3-1.1-.4-1.2-1.1-1.5-1.1-1.5-.9-.6.1-.6.1-.6 1 0 1.6 1 1.6 1 .9 1.6 2.4 1.1 2.9.9.1-.7.4-1.1.7-1.4-2.2-.3-4.5-1.1-4.5-5A3.9 3.9 0 0 1 6.3 9a3.6 3.6 0 0 1 .1-2.6s.8-.3 2.7 1a9.4 9.4 0 0 1 5 0c1.9-1.3 2.7-1 2.7-1a3.6 3.6 0 0 1 .1 2.6 3.9 3.9 0 0 1 1.1 2.7c0 3.9-2.3 4.7-4.5 5 .4.3.7.9.7 1.8v3A10 10 0 0 0 12 2Z" />
                  </svg>
                </a>
              </nav>

              <div className="views" aria-label="Visualizzazioni">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                <span id="viewCount">0</span>
              </div>
            </div>
          </section>
        </div>
      </main>

      <div
        className="enter-screen"
        id="enterScreen"
        role="button"
        tabIndex={0}
        aria-label="Clicca ovunque per entrare"
      >
        <div className="enter-content" id="enterContent">
          <h1 className="enter-brand">ayoitsaxto</h1>
          <p className="enter-hint">click to enter</p>
        </div>
      </div>

      <audio id="bgAudio" src={backgroundMusic} loop preload="auto" />
    </>
  );
}
